(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bros-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const clearSelection = (root) => {
      root.querySelectorAll('.bros__card').forEach((card) => card.setAttribute('aria-checked', 'false'));
      const none = root.querySelector('[data-bros-none]');
      if (none) none.setAttribute('aria-checked', 'true');
    };

    const setError = (root, message) => {
      const box = root.querySelector('[data-bros-error]');
      if (!box) return;
      box.textContent = message || '';
      box.hidden = !message;
    };

    const syncForm = (root) => {
      const form = root.closest('form');
      if (!form) return;
      form.classList.toggle('has-bros', Boolean(root.querySelector('.bros__card[aria-checked="true"]')));
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const card = target.closest('[data-bros] .bros__card');
      if (card && !card.disabled) {
        const root = card.closest('[data-bros]');
        const wasSelected = card.getAttribute('aria-checked') === 'true';
        clearSelection(root);
        if (!wasSelected) {
          card.setAttribute('aria-checked', 'true');
          const none = root.querySelector('[data-bros-none]');
          if (none) none.setAttribute('aria-checked', 'false');
        }
        setError(root, '');
        syncForm(root);
        return;
      }

      const none = target.closest('[data-bros-none]');
      if (none) {
        const root = none.closest('[data-bros]');
        clearSelection(root);
        setError(root, '');
        syncForm(root);
      }
    });

    const setBusy = (form, busy) => {
      const scope = form.closest('[data-product]') || document;
      scope.querySelectorAll('[data-add-to-cart]').forEach((button) => {
        if (busy) {
          button.dataset.brosLabel = button.textContent;
          button.dataset.brosWasDisabled = button.disabled ? '1' : '0';
          button.disabled = true;
          button.textContent = 'Ekleniyor…';
        } else if (button.dataset.brosLabel !== undefined) {
          button.textContent = button.dataset.brosLabel;
          button.disabled = button.dataset.brosWasDisabled === '1';
          delete button.dataset.brosLabel;
          delete button.dataset.brosWasDisabled;
        }
      });
    };

    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const root = form.querySelector('[data-bros]');
        if (!root) return;

        const selected = root.querySelector('.bros__card[aria-checked="true"]');
        if (!selected) return;

        event.preventDefault();
        if (form.dataset.brosBusy === '1') return;

        const mainInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('[name="quantity"]');
        const mainId = mainInput ? Number(mainInput.value) : 0;
        const quantity = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1);
        const brosId = Number(selected.getAttribute('data-bros-id'));
        if (!mainId || !brosId) return;

        form.dataset.brosBusy = '1';
        setBusy(form, true);
        setError(root, '');

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                { id: mainId, quantity: quantity },
                { id: brosId, quantity: 1 },
              ],
            }),
          });

          if (!response.ok) {
            const message =
              response.status === 422
                ? 'Seçtiğiniz ürün veya broş şu anda yeterli stokta olmayabilir. Lütfen seçiminizi kontrol edip tekrar deneyin.'
                : 'Ürün sepete eklenirken bir sorun oluştu. Lütfen tekrar deneyin.';
            throw new Error(message);
          }

          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          setError(
            root,
            error instanceof Error && error.message && error.message !== 'Failed to fetch'
              ? error.message
              : 'Bağlantı sorunu nedeniyle ürün sepete eklenemedi. Lütfen tekrar deneyin.'
          );
          form.dataset.brosBusy = '0';
          setBusy(form, false);
        }
      },
      true
    );

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      document.querySelectorAll('form[data-bros-busy], .product__form').forEach((form) => {
        form.dataset.brosBusy = '0';
        setBusy(form, false);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-groups"] && !Shopify.designMode) return;
  try {
    (() => {
    const sync = (row) => {
      const track = row.querySelector('[data-row-track]');
      const bar = row.querySelector('[data-row-scrollbar]');
      const thumb = row.querySelector('[data-row-thumb]');
      if (!track || !bar || !thumb) return;

      const max = track.scrollWidth - track.clientWidth;
      row.classList.toggle('product-row--static', max <= 1);
      if (max <= 1) return;

      const barWidth = bar.clientWidth;
      const thumbWidth = Math.max(40, barWidth * (track.clientWidth / track.scrollWidth));
      const travel = barWidth - thumbWidth;
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translate(' + (track.scrollLeft / max) * travel + 'px, -50%)';
    };

    const syncAll = () => {
      document.querySelectorAll('[data-row]').forEach(sync);
    };

    document.addEventListener(
      'scroll',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element) || !target.hasAttribute('data-row-track')) return;
        const row = target.closest('[data-row]');
        if (row) sync(row);
      },
      { capture: true, passive: true }
    );

    document.addEventListener('pointerdown', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const bar = target.closest('[data-row-scrollbar]');
      if (!bar) return;

      const row = bar.closest('[data-row]');
      const track = row && row.querySelector('[data-row-track]');
      const thumb = bar.querySelector('[data-row-thumb]');
      if (!track || !thumb) return;

      const max = track.scrollWidth - track.clientWidth;
      const barWidth = bar.clientWidth;
      const thumbWidth = thumb.offsetWidth;
      const travel = barWidth - thumbWidth;
      if (max <= 1 || travel <= 0) return;

      event.preventDefault();
      const barLeft = bar.getBoundingClientRect().left;

      if (!target.closest('[data-row-thumb]')) {
        const wanted = event.clientX - barLeft - thumbWidth / 2;
        track.scrollLeft = (Math.min(Math.max(wanted, 0), travel) / travel) * max;
      }

      const startX = event.clientX;
      const startScroll = track.scrollLeft;
      thumb.classList.add('is-dragging');
      track.style.scrollSnapType = 'none';
      bar.setPointerCapture(event.pointerId);

      const move = (moveEvent) => {
        const delta = moveEvent.clientX - startX;
        track.scrollLeft = startScroll + delta * (max / travel);
      };
      const end = (endEvent) => {
        thumb.classList.remove('is-dragging');
        track.style.scrollSnapType = '';
        if (bar.hasPointerCapture(endEvent.pointerId)) bar.releasePointerCapture(endEvent.pointerId);
        bar.removeEventListener('pointermove', move);
        bar.removeEventListener('pointerup', end);
        bar.removeEventListener('pointercancel', end);
      };

      bar.addEventListener('pointermove', move);
      bar.addEventListener('pointerup', end);
      bar.addEventListener('pointercancel', end);
    });

    window.addEventListener('resize', syncAll);
    window.addEventListener('load', syncAll);
    document.addEventListener('shopify:section:load', syncAll);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const api = (window.fiyellaCart = window.fiyellaCart || {});
    const getDialog = () => document.querySelector('dialog[data-qa-dialog]');
    let opener = null;

    const getData = (root) => {
      if (!root._qaData) {
        const el = root.querySelector('[data-qa-json]');
        try {
          root._qaData = el ? JSON.parse(el.textContent) : { variants: [] };
        } catch (error) {
          root._qaData = { variants: [] };
        }
      }
      return root._qaData;
    };

    const setError = (root, message) => {
      const box = root.querySelector('[data-qa-error]');
      if (!box) return;
      box.textContent = message || '';
      box.hidden = !message;
    };

    const applyVariant = (root, variant) => {
      const submit = root.querySelector('[data-qa-submit]');
      const available = Boolean(variant && variant.available);
      setError(root, '');

      if (submit) {
        if (available) {
          submit.removeAttribute('aria-disabled');
        } else {
          submit.setAttribute('aria-disabled', 'true');
        }
        submit.textContent = available ? 'Sepete Ekle' : variant ? 'Tükendi' : 'Bu seçim mevcut değil';
      }
      if (!variant) return;

      root.dataset.variantId = String(variant.id);
      const price = root.querySelector('[data-qa-price]');
      if (price) price.textContent = variant.price;
      const compare = root.querySelector('[data-qa-compare]');
      if (compare) {
        compare.hidden = !variant.compare;
        if (variant.compare) compare.textContent = variant.compare;
      }
    };

    api.openQuickAdd = async (button) => {
      const dialog = getDialog();
      const content = dialog && dialog.querySelector('[data-qa-content]');
      const productUrl = button.dataset.productUrl;
      if (!content) {
        if (productUrl) window.location.assign(productUrl);
        return;
      }

      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');

      try {
        const separator = productUrl.indexOf('?') === -1 ? '?' : '&';
        const response = await fetch(productUrl + separator + 'section_id=quick-add-options', {
          headers: { Accept: 'text/html' },
        });
        if (!response.ok) throw new Error('quick add');

        const html = await response.text();
        const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-qa]');
        if (!node) throw new Error('quick add');

        content.innerHTML = node.outerHTML;
        opener = button;
        dialog.showModal();

        const checked = content.querySelector('.qa__input:checked') || content.querySelector('.qa__input');
        if (checked) checked.focus({ preventScroll: true });
      } catch (error) {
        // Without the dialog the customer still reaches the product page to choose there.
        window.location.assign(productUrl);
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('qa__input')) return;
      const root = input.closest('[data-qa]');
      if (!root) return;

      const selected = Array.from(root.querySelectorAll('.qa__option')).map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      const variant = getData(root).variants.find((candidate) =>
        candidate.options.every((option, index) => option === selected[index])
      );
      applyVariant(root, variant);
    });

    document.addEventListener('click', async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const dialog = getDialog();
      if (!dialog || !dialog.open) return;

      if (target === dialog || target.closest('[data-qa-close]')) {
        dialog.close();
        return;
      }

      const submit = target.closest('[data-qa-submit]');
      if (!submit || submit.getAttribute('aria-disabled') === 'true') return;

      const root = submit.closest('[data-qa]');
      const variantId = root ? Number(root.dataset.variantId) : 0;
      if (!variantId || !window.fiyellaCart || !window.fiyellaCart.add) return;

      submit.setAttribute('aria-disabled', 'true');
      const from = opener;
      dialog.close();
      const result = await window.fiyellaCart.add([{ id: variantId, quantity: 1 }], { opener: from });

      if (result && result.ok && from) {
        from.classList.add('is-added');
        window.setTimeout(() => from.classList.remove('is-added'), 1600);
      }
    });

    document.addEventListener(
      'close',
      (event) => {
        const dialog = event.target;
        if (!(dialog instanceof HTMLDialogElement) || !dialog.hasAttribute('data-qa-dialog')) return;
        const content = dialog.querySelector('[data-qa-content]');
        if (content) content.innerHTML = '';
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    (() => {
    const pending = new Set();

    const setState = (button, name) => {
      button.classList.toggle('is-loading', name === 'loading');
      button.classList.toggle('is-added', name === 'added');
      if (name === 'loading') {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', async (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('[data-quick-add]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      if (button.getAttribute('aria-disabled') === 'true') return;

      const cart = window.fiyellaCart;
      if (!cart) return;

      const variantId = Number(button.dataset.variantId);
      if (!variantId) {
        if (cart.openQuickAdd) cart.openQuickAdd(button);
        return;
      }

      if (pending.has(variantId)) return;
      pending.add(variantId);
      setState(button, 'loading');

      let result = { ok: false };
      try {
        result = await cart.add([{ id: variantId, quantity: 1 }], { opener: button });
      } finally {
        pending.delete(variantId);
      }

      if (result && result.ok) {
        setState(button, 'added');
        window.setTimeout(() => setState(button, ''), 1600);
      } else {
        setState(button, '');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
